<template>
	<div>
		<v-layout wrap>
			<v-flex xs12>
				<v-checkbox
					class="input-checkbox input-booking generic-checkbox"
					label="Cliente Genérico"
					v-model="customer.flagGeneric"
					color="info"
					v-tooltip:right="{ html: 'Usar esta opción cuando no se tenga el documento del huésped.' }"
					hide-details>
				</v-checkbox>
			</v-flex>
		</v-layout>
		<v-layout wrap v-if="genericCustomer">
			<v-flex xs12 text-xs-left mb-2>
				<label class="label-title">Completa los datos</label>
			</v-flex>
			<v-flex xs12 text-xs-left>
				<label class="label-form">Nº de Tarjeta</label>
			</v-flex>
			<v-flex xs3>
				<select-button
					class="filter-select filter-select-indicator"
					item-text="name"
					item-value="id"
					:items="typeCards"
					v-model="typeCard"
				/>
				<input-text v-model="customer.cardVip"/>
			</v-flex>
		</v-layout>
		<v-layout>
			<v-flex xs12 text-xs-left>
				<v-layout row>
					<v-flex xs3 mb-3 txt-xs-left>
						<type-document-input
							label-text="Tipo de identificación"
							:subsidiary="subsidiaryId"
							@customer-not-found="customerNotFound"
							@customer-data="setCustomer"
						/>
						<span class="caption red--text"
							v-if="$v.customer.entity.documentType && $v.customer.entity.documentType.$invalid">
							El tipo de documento es requerido.
						</span>
						<span class="caption red--text"
							v-if="$v.customer.entity.numDocument && $v.customer.entity.numDocument.$invalid">
							El número de documento es requerido
						</span>
						<p class="caption red--text mb-0"
							v-if="$v.customer.entity.numDocument && $v.customer.entity.numDocument.$invalid
								&& $v.customer.entity.numDocument.$params.minLength">
							Es necesario ingresar {{ $v.customer.entity.numDocument.$params.minLength.min }} dígitos
						</p>
					</v-flex>
					<v-flex xs3 mb-3 :class="{ 'xs6' : !isNaturalPerson }">
						<input-text
							:label-text="nameLabel"
							:disabled="!customer.entity.numDocument"
							v-model="customer.name"
						/>
						<span class="caption red--text"
							v-if="$v.customer.name && $v.customer.name.$invalid">
							{{ nameMessage }}
						</span>
					</v-flex>
					<v-flex xs3 mb-3 v-if="isNaturalPerson">
						<input-text
							label-text="Apellidos"
							:disabled="!customer.entity.numDocument"
							v-model="customer.lastname"
						/>
						<span class="caption red--text"
							v-if="$v.customer.lastname && $v.customer.lastname.$invalid">
							El apellido es requerido
						</span>
					</v-flex>
					<v-flex xs3 mb-3>
						<input-text
							type="email"
							label-text="Correo electrónico"
							:disabled="!customer.entity.numDocument"
							v-model="customer.email"
						/>
						<span class="caption red--text"
							v-if="$v.customer.email && $v.customer.email.$invalid">
							Correo inválido
						</span>
					</v-flex>
					<v-flex xs1 v-if="showCustomerRate" class="customer-rate">
						<v-btn
							class="btn-save mt-4"
							@click="onShowRateModal"
						>Tarifario</v-btn>
						<transition name="slide-fade">
							<rate-modal
								v-if="flagShowRateModal"
								class="rate-modal"
								:subsidiary-id="subsidiaryId"
								:customer-whith-rate="showCustomerRate"
								:rates="rateAvailability"
							/>
						</transition>
					</v-flex>
				</v-layout>
				<v-layout row wrap v-if="genericCustomer">
					<v-flex xs3 mb-3>
						<label class="label-form">Fecha de nacimiento</label>
						<v-layout row wrap>
							<v-flex xs4 pa-0>
								<v-text-field
									class="input-regular input-label-select"
									value="Adulto"
									hide-details
									readonly>
								</v-text-field>
							</v-flex>
							<v-flex xs8 py-0 pl-0>
								<select-date
									:disabled="!customer.entity.numDocument"
									v-model="customer.dateBirth"
								/>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs3 mb-3 v-if="isNaturalPerson">
						<select-button
							label-text="Estado civil"
							item-text="name"
							item-value="id"
							:disabled="!customer.entity.numDocument"
							:items="civilStatus"
							v-model="customer.civilStatus"
						/>
					</v-flex>
					<v-flex xs3 mb-3 v-if="isNaturalPerson">
						<select-button
							label-text="Género"
							item-text="name"
							item-value="id"
							:items="genders"
							:disabled="!customer.entity.numDocument"
							v-model="customer.gender"
						/>
					</v-flex>
					<v-flex xs3>
						<select-button
							autocomplete
							label-text="País"
							item-text="name"
							item-value="id"
							:disabled="!customer.entity.numDocument"
							:items="countries"
							v-model="customer.countryId"
							@input="loadCities"
						/>
					</v-flex>
					<v-flex xs3>
						<select-button
							autocomplete
							label-text="Ciudad"
							item-text="province"
							item-value="id"
							:disabled="!customer.entity.numDocument"
							:items="citiesByCountry"
							v-model="customer.cityId"
						/>
					</v-flex>
					<v-flex xs3 mb-3>
						<input-text
							type='tel'
							label-text="Teléfono"
							:disabled="!customer.entity.numDocument"
							v-model="customer.phone"
						/>
					</v-flex>
					<v-flex xs6 mb-3>
						<input-text
							type='tel'
							label-text="Dirección"
							:disabled="!customer.entity.numDocument"
							v-model="customer.address"
						/>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import { maxLength, minLength, required, email } from 'vuelidate/lib/validators';
import selectButton from '@/clerkinn/shared/select-button';
import inputText from '@/clerkinn/shared/input-text';
import typeDocumentInput from '@/clerkinn/shared/type-document-input';
import selectDate from '@/clerkinn/shared/select-date';
import lib from '@/shared/lib';

const { compose, setNewProperty } = lib;

function created() {
	this.loadCountries();
}

async function loadCountries() {
	const { data: countries } = await this.$http.get(`${process.env.PMS_URL}/countries`);
	this.countries = countries.data;
}

async function searchCustomer() {
	let customer = {};
	if (this.model.numDocument !== '') {
		if (this.model.documentType === 4) {
			try {
				const url = `${process.env.PMS_URL}/customer-search`;
				const params = {
					numDocument: this.model.numDocument,
					documentType: this.model.documentType,
				};
				(
					{ data: customer } = await this.$http.get(url, { params })
				);
			} catch (error) {
				customer = {};
				this.showNotification('La empresa no se encuentra registrada como cliente', 'warning');
			}
		}
		try {
			if (!customer.data) {
				(
					{ data: customer } = await this.mixinSearchCustomer(
						this.model.documentType,
						this.model.numDocument,
					)
				);
			}
			if (customer.data) {
				this.rateAvailability = customer.data.flagRate
					? [...customer.data.rateAvailability]
					: [];
				this.model = this.getCustomerData(customer.data);
				this.model.flagGeneric = false;
				if (!this.model.flagTaxes) {
					this.$set(this.model, 'flagTaxes', false);
				}
				this.showNotification('Cliente conseguido !', 'success');
			}
		} catch (error) {
			if (this.model.documentType === 4) {
				this.showNotification('La empresa no se encuentra registrada como cliente', 'warning');
			} else {
				this.showNotification('La persona no se encuentra registrada como cliente', 'warning');
			}
			const numDocument = this.model.numDocument;
			const flagGeneric = this.model.flagGeneric;
			this.model = this.defaultModel();
			this.model.numDocument = numDocument;
			this.model.flagGeneric = flagGeneric;
			this.model.countryId = process.env.DEFAULT_COUNTRY_ID;
		}
	}
}

function genericCustomer() {
	return !this.customer.flagGeneric;
}

function nameLabel() {
	return this.isNaturalPerson ? 'Nombres' : 'Razón Social';
}

function isNaturalPerson() {
	return this.customer.documentType !== 4;
}

function nameMessage() {
	return this.isNaturalPerson ? 'El nombre es requerido' : 'La razón social es requerida';
}

function showCustomerRate() {
	return this.customer.flagRate;
}

function onShowRateModal() {
	this.flagShowRateModal = !this.flagShowRateModal;
}

async function loadCities(id) {
	this.customer.cityId = 0;
	const params = { countryId: id };
	const { data: cities } = await this.$http.get(`${process.env.PMS_URL}/cities`, { params });
	if (this.customer.city && this.customer.city.data) {
		this.customer.cityId = this.customer.city.data.id;
	}
	this.citiesByCountry = cities.data;
}

function numDocumentLength() {
	if (this.customer.documentType === 1) {
		return 8;
	} else if (this.customer.documentType === 4) {
		return 11;
	}
	return 0;
}

function customerNotFound({ numDocument, documentType }) {
	this.clearCustomerData();
	this.customer.entity = compose(
		setNewProperty('numDocument', numDocument),
		setNewProperty('documentType', documentType),
	)(this.customer.entity);
}

function clearCustomerData() {
	this.customer = {
		address: '',
		cardVip: '',
		cityId: 0,
		countryId: 0,
		civilStatus: 1,
		dateBirth: '',
		entity: {
			documentType: '',
			numDocument: '',
		},
		email: '',
		flagGeneric: this.customer.flagGeneric,
		gender: '',
		lastname: '',
		name: '',
		phone: '',
	};
}

function invalidFunction(value) {
	this.$emit('invalid-customer-info', value);
}

function trackingCustomer(customerInfo) {
	this.$emit('customer-info', customerInfo);
}

function validations() {
	const customer = {
		entity: {
			documentType: { required },
			numDocument: { required },
		},
		email: { email },
		lastname: { required },
		name: { required },
	};
	if (this.numDocumentLength > 0) {
		customer.entity.numDocument.maxLength = maxLength(this.numDocumentLength);
		customer.entity.numDocument.minLength = minLength(this.numDocumentLength);
	}
	return { customer };
}

function setCustomer(customer) {
	this.customer.name = customer.data.name;
	this.customer.lastname = customer.data.lastname;
	this.customer.email = customer.data.email;
	this.customer.entity.documentType = customer.data.documentType;
	this.customer.entity.numDocument = customer.data.numDocument;
}

function data() {
	return {
		citiesByCountry: [],
		civilStatus: [
			{ id: 1, name: 'Soltero(a)' },
			{ id: 2, name: 'Casado(a)' },
			{ id: 3, name: 'Viudo(a)' },
			{ id: 4, name: 'Divorciado(a)' },
		],
		countries: [],
		customer: {
			address: '',
			cardVip: '',
			cityId: 0,
			countryId: 0,
			civilStatus: 1,
			dateBirth: '',
			entity: {
				documentType: '',
				numDocument: '',
			},
			email: '',
			flagGeneric: true,
			gender: '',
			lastname: '',
			name: '',
			phone: '',
		},
		flagShowRateModal: false,
		genders: [
			{ id: 1, name: 'Hombre' },
			{ id: 2, name: 'Mujer' },
		],
		rateAvailability: [],
		typeCard: '',
		typeCards: [],
	};
}

export default {
	name: 'generic-customer-generic',
	components: {
		inputText,
		selectButton,
		selectDate,
		typeDocumentInput,
	},
	computed: {
		genericCustomer,
		isNaturalPerson,
		nameLabel,
		nameMessage,
		numDocumentLength,
		showCustomerRate,
	},
	created,
	data,
	methods: {
		clearCustomerData,
		customerNotFound,
		invalidFunction,
		loadCities,
		loadCountries,
		onShowRateModal,
		searchCustomer,
		setCustomer,
		trackingCustomer,
	},
	props: {
		subsidiaryId: {
			default: 0,
			type: [Number, String],
		},
	},
	validations,
	watch: {
		customer: {
			deep: true,
			handler: trackingCustomer,
		},
		'$v.$invalid': invalidFunction,
	},
};
</script>




// WEBPACK FOOTER //
// GenericCustomerComponent.vue?9cdddcac